<template>
	<div class="jmhome">

		<div class="nr">
			<div class="left">
				<div class="top">
					<div class="bt">
						<img class="bt-img" src="../../../../../static/img/comm/home.png" />
						<div>{{paiming.title}}</div>
					</div>
					<paiming  v-if="hackResetpaiming" :items="paiming.items"></paiming>
				</div>
				<div class="down">
					<div class="bt">
						<img class="bt-img" src="../../../../../static/img/comm/home.png" />
						<div>{{bzt.title}}</div>
						
					</div>
					<bingzhuangtu v-if="hackResetbingzhuangtu" :data1="bzt.data1" :name='bzt.name' :data2='bzt.data2'></bingzhuangtu>
				</div>
			</div>
			<div class="centre">
				<div class="top">
					<div class="bt">
						<img class="bt-img" src="../../../../../static/img/comm/home.png" />
						<div style="width: 40%;">{{zexiantu.title}}</div>
						<div>
							<RadioGroup  @on-change="onchange()" v-model="single">
								<Radio label="0">
									<span >销售额</span>
								</Radio>
								<Radio label="1">
									<span >订单数</span>
								</Radio>
								<Radio label="2">
									<span >设备数</span>
								</Radio>
							</RadioGroup>
						</div>
					</div>
					<zexiantu v-if="hackResetzexiantu" :data1='zexiantu.data1' :data2="zexiantu.data2" :date="zexiantu.date"  minWidth="500px"></zexiantu>
				</div>
				<div class="down">
					<div class="bt">
						<img class="bt-img" src="../../../../../static/img/comm/home.png" />
						<div>点位分布</div>
					</div>
					<ditu v-if="hackResetditu" :zxd="zxd" :qt="qt" :h="h" :zoom="zoom"></ditu>
				</div>
			</div>
			<div class="right">

				<yuanhuan v-if="hackResetyh" :yhs="yhs"></yuanhuan>
			</div>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import zexiantu from '@/components/comm/home/zexiantu.vue'
	import paiming from '@/components/comm/home/paiming.vue'
	import bingzhuangtu from '@/components/comm/home/bingzhuangtu.vue'
	import ditu from '@/components/comm/ditu/ditu.vue'
	import yuanhuan from '@/components/comm/home/yuanhuan.vue'
	export default {

		data() {
			return {
				//地图
				h:"400px",
				zoom:2,
				zxd: [106.49275526969987, 29.61166095192132], //中心点坐标
				qt: [
					/* {position: [121.5263285, 31.21415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'},
					{position: [121.5273285, 31.29415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'} */
				],
				//地图
				single:'0',
				hackResetpaiming: false,
				hackResetbingzhuangtu: false,
				hackResetzexiantu: false,
				hackResetyh: false,
				hackResetditu:false,
				zxtMap:{},
				bzt: {
					title: '设备类型',
					data1: [],
					name: '设备分类',
					data2: [
						/* {
							value: 335,
							name: '小吃'
						} */
					]
				},
				paiming: {
					title: '本月销售额排名',
					items: [{
							id: 1,
							type: 'error',
							pm: 'TOP1',
							address: '暂无',
							bfb: 0,
							sl: 0
						},
						{
							id: 2,
							type: 'warning',
							pm: 'TOP2',
							address: '暂无',
							bfb: 0,
							sl: 0
						},
						{
							id: 3,
							type: 'primary',
							pm: 'TOP3',
							address: '暂无',
							bfb: 0,
							sl: 0
						},
						{
							id: 4,
							type: 'info',
							pm: 'TOP4',
							address: '暂无',
							bfb: 0,
							sl: 0
						},
						{
							id: 5,
							type: 'info',
							pm: 'TOP5',
							address: '暂无',
							bfb: 0,
							sl: 0
						}
					]
				},
				zexiantu: {
					title: '数据统计',
					data1: ['销售额','订单数','设备数'],
					data2: [{
							name: '销售额',
							type: 'line',
							stack: '总量',
							data: []
						}
					],
					date:[]
				},
				yhs: [{
						id: 1,
						number: 12,
						title: '销售总额',
						bl: 5
					},
					{
						id: 2,
						number: 12,
						title: '设备总数',
						bl: 5
					},
					{
						id: 3,
						number: 0,
						title: '订单总数',
						bl: 5
					}
				]
			}
		},
		methods: {
			queryzexiantu() {
				let _this = this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/mac/home/jm',
				    data: _this.formValidate,
					_this: _this,
					success: function(data) {
						_this.zxtMap=data.map.monthMoney
						let bztType=data.map.macType
						let macMoney=data.map.macMoney
						let total=data.map.total
						let macs=data.map.macs
						_this.huizhiZexiantu("0")
						_this.huizhibzt(bztType)
						_this.huizhiPaiming(macMoney)
						_this.huizhiyhs(total)
						_this.huizhiditu(macs)
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			huizhiZexiantu(i){
				
				let _this=this
				_this.zexiantu.date=[_this.zxtMap.dateMap.date0,_this.zxtMap.dateMap.date1,_this.zxtMap.dateMap.date2,_this.zxtMap.dateMap.date3,
				_this.zxtMap.dateMap.date4,_this.zxtMap.dateMap.date5,
				_this.zxtMap.dateMap.date6,_this.zxtMap.dateMap.date7,_this.zxtMap.dateMap.date8,
				_this.zxtMap.dateMap.date9,_this.zxtMap.dateMap.date10,_this.zxtMap.dateMap.date11]
				
				console.log(i)
				switch (i){
					case '0':
					let map1=_this.zxtMap.map1
					_this.zexiantu.data2[0].name='销售额'
					_this.zexiantu.data2[0].data=[map1.money0/100,map1.money1/100,map1.money2/100,map1.money3/100,
					map1.money4/100,map1.money5/100,map1.money6/100,map1.money7/100,map1.money8/100,map1.money9/100,
					map1.money10/100,map1.money11/100]
						break;
					case '1':
					   let map2=_this.zxtMap.map2
					_this.zexiantu.data2[0].name='设备数'
					_this.zexiantu.data2[0].data=[map2.macNumber0,map2.macNumber1,map2.macNumber2,map2.macNumber3,
					map2.macNumber4,map2.macNumber5,map2.macNumber6,map2.macNumber7,map2.macNumber8,map2.macNumber9,
					map2.macNumber10,map2.macNumber11]
						break;
					case '2':
					let map3=_this.zxtMap.map3
					_this.zexiantu.data2[0].name='订单数'
					_this.zexiantu.data2[0].data=[map3.orderNumber0,map3.orderNumber1,map3.orderNumber2,map3.orderNumber3,
					map3.orderNumber4,map3.orderNumber5,map3.orderNumber6,map3.orderNumber7,map3.orderNumber8,map3.orderNumber9,
					map3.orderNumber10,map3.orderNumber11]
						break;
					default:
						break;
				}
				console.log(_this.zxtMap.map3)
				console.log(_this.zxtMap.map2)
				//重新渲染子组件
				this.hackResetzexiantu = false
				this.$nextTick(() => {
					this.hackResetzexiantu = true
				})
			},
			onchange(){
				let _this=this
				_this.huizhiZexiantu(_this.single)
			},
			huizhibzt(types){
				let _this=this
				for (let i = 0; i < types.length; i++) {
					
					_this.bzt.data1.push(types[i].name)
					_this.bzt.data2.push({value:types[i].number,name:types[i].name})
				}
				//重新渲染子组件
				this.hackResetbingzhuangtu = false
				this.$nextTick(() => {
					this.hackResetbingzhuangtu = true
				})
			},
			huizhiPaiming(macMoney){
				let _this=this
				let paiming=_this.paiming.items
				for (let i = 0; i < macMoney.length; i++) {
					paiming[i].address=macMoney[i].mergerName
					paiming[i].sl=macMoney[i].money/100
					paiming[i].bfb=macMoney[i].money/macMoney[0].money*100
				}
				//重新渲染子组件
				this.hackResetpaiming = false
				this.$nextTick(() => {
					this.hackResetpaiming = true
				})
			},
			huizhiyhs(total){
				let _this=this
				_this.yhs[0].number=total.saleroom/100
				_this.yhs[1].number=total.macNumber
				_this.yhs[2].number=total.orderNumber
				
				
				_this.yhs[0].bl=total.saleroom/total.saleroom1*100
				_this.yhs[1].bl=total.macNumber/total.macNumber1*100
				_this.yhs[2].bl=total.orderNumber/total.orderNumber1*100
				//重新渲染子组件
				this.hackResetyh = false
				this.$nextTick(() => {
					this.hackResetyh = true
				})
			},
			huizhiditu(a){
				console.log(a)
				let _this=this
				for (var i = 0; i < a.length; i++) {
					let latitude = parseFloat(a[i].latitude)
					let longitude = parseFloat(a[i].longitude)
					let b = {
						position: [longitude, latitude],
						id: a[i].id,
						url: '/main/jm/platform/allianceMacAisle/list',
						address: a[i].address,
						code: a[i].macCode,
					}
					_this.qt.push(b)
				}
				//重新渲染子组件
				this.hackResetditu = false
				this.$nextTick(() => {
					this.hackResetditu = true
				})
			}
			
		},
		components: {
			zexiantu,
			paiming,
			bingzhuangtu,
			ditu,
			yuanhuan
		},
		created() {
			let _this = this
			_this.queryzexiantu()
		}

	}
</script>
<style scoped lang="less">
	.jmhome {
		display: flex;
		flex-direction: column;
	}


	.nr {
		display: flex;
		justify-content: space-between;

		.left {
			.top {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}

			.down {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}
		}

		.centre {


			.top {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}

			.down {
				padding: 5px 5px 0px 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}
		}

		.right {}

	}
</style>



// WEBPACK FOOTER //
// src/components/home/jm/platform/shebeitongji.vue